import { useEffect, useState } from "react";
import { TaskCard } from "../components/taskCard";
import { Typography, Box } from "@mui/material";
import { Spinner } from "../../../../components/Commons/Spinner/Spinner";
import { useTranslation } from "react-i18next";
import { ProjectTaskDashboard } from "../../../../interfaces/Projects/projectTaskDashboard";
import { Menuitem } from "../../../../interfaces/Security/menu";
import { FieldType } from "../../../../interfaces/Projects/Catalogs/fieldTypes";
import { useProjectTaskDashboardStore } from "../../../../store/Projects/ProjectTaskDashboard/ProjectTaskDashboardStore";
import { ProjectTaskDashBoardFilter } from "../components/DashboardFilter/projectTaskDashBoardFilter";

interface TableProjectTaskListProps {
  color: number[] | undefined;
  isEdit: boolean;
  projectGroupId: number | undefined;
  resourceScreen: Menuitem;
  comboFieldTypes: FieldType[];
  isLoadingDataTable: boolean
}

export const TableProjectTaskList = ({ color,
  isEdit,
  projectGroupId,
  resourceScreen,
  comboFieldTypes,
  isLoadingDataTable
}: TableProjectTaskListProps) => {
  const [t] = useTranslation("global");
  const [filterProjectTasksData, setFilterProjectTasksData] = useState<ProjectTaskDashboard[]>([])
  const projectTasks = useProjectTaskDashboardStore(store => store.projectTasks);
  const [filterValue, setFilterValue] = useState<string>('');
  const handleFilter = (searchTerm: string) => {
    setFilterValue(searchTerm);
    if (projectTasks.length > 0) {
      const lowerCaseSearchTerm = searchTerm.toLowerCase();
      const filteredData = projectTasks.filter((projecttask) =>
        Object.keys(projecttask).some((key) => {
          const fieldValue = projecttask[key as keyof ProjectTaskDashboard];
          return (
            typeof fieldValue === 'string' &&
            fieldValue.toLowerCase().includes(lowerCaseSearchTerm)
          );
        })
      );
      setFilterProjectTasksData(filteredData);
    }
  };

  const clearFilter = () => {
    setFilterValue('');
    setFilterProjectTasksData(projectTasks);
  };

  useEffect(() => {
    if (!isLoadingDataTable) {
      if(filterValue){
        handleFilter(filterValue)
        return;
      }
      setFilterProjectTasksData(projectTasks);
    }
  }, [isLoadingDataTable, projectTasks]);


  return (
    <>
      {isLoadingDataTable && <Spinner />}
      {!isLoadingDataTable && projectTasks.length > 0 ? (
        <>
          <div className="d-flex justify-content-end">
            <ProjectTaskDashBoardFilter
              onFilterChange={handleFilter}
              onClearFilter={clearFilter}
              filterValue={filterValue}
            />
          </div>
          {filterProjectTasksData.map((task) => (
            <TaskCard
              key={task.project_task_id}
              task={task}
              color={color}
              isEdit={isEdit}
              resourceScreen={resourceScreen}
              comboFieldTypes={comboFieldTypes}
            />
          ))}
        </>
        ) : (
        <Box
          sx={{
            justifyContent: "center",
            marginBlock: 2,
            display: "flex",
          }}
        >
          <Typography>{t('projecttaskdashboard.messages.no-tasks')}</Typography>
        </Box>
      )}
    </>
  );
};
